package com.solevo.dist.network.firebase.api.orders

import com.solevo.dist.application.models.Cart
import com.solevo.dist.application.models.CartItem
import com.solevo.dist.application.models.Order
import com.solevo.dist.application.models.User.Companion.currentCustomerId
import com.solevo.dist.application.models.User.Companion.legalId
import com.solevo.dist.network.api.orders.OrderRemoteSource
import com.solevo.dist.network.firebase.api.orders.models.FirebaseOrder
import com.solevo.dist.network.firebase.api.orders.models.toOrder
import com.solevo.dist.network.implementation.firebase.FirebaseFields
import com.solevo.dist.network.implementation.firebase.FirestoreCollections
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth
import dev.gitlive.firebase.firestore.FieldValue
import dev.gitlive.firebase.firestore.Filter
import dev.gitlive.firebase.firestore.firestore
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.flow.mapNotNull

/**
 * Created by Ilija Vucetic on 30.9.25..
 * Copyright (c) 2025 Aktiia. All rights reserved.
 */
class OrderFirebaseRemoteSource(
    private val db: dev.gitlive.firebase.firestore.FirebaseFirestore = Firebase.firestore,
    private val auth: dev.gitlive.firebase.auth.FirebaseAuth = Firebase.auth
) : OrderRemoteSource {

    private val currentUserId: String
        get() = auth.currentUser?.uid ?: ""


    override fun getOrdersLive(): Flow<List<Order>> {
        println("Fetching orders for customer: ${currentCustomerId.value} and legal entity: $legalId")

        return db.collection(FirestoreCollections.ORDERS_COLLECTION)
            .where { FirebaseFields.CUSTOMER_ID equalTo currentCustomerId.value }

            .snapshots
            .map { querySnap ->
                println("Ukupno ima ${querySnap.documents.size} dokumenata")
                querySnap.documents.mapNotNull { it.data<FirebaseOrder?>()?.toOrder() }
            }
    }

    override fun getOrder(orderId: String): Flow<Order?> {
        return db.collection(FirestoreCollections.ORDERS_COLLECTION)
            .where { FirebaseFields.ORDER_ID equalTo orderId }
            .where { FirebaseFields.LEGAL_ENTITY_ID equalTo legalId }
            .snapshots
            .map { snap ->
                val first = snap.documents.firstOrNull() ?: return@map null
                first.data<FirebaseOrder?>()?.toOrder()
            }
    }

    override suspend fun addNewOrder(cartItem: CartItem): Result<Boolean> = runCatching {
        val hasCart = isCartCreated()

        if (hasCart) {
            addItemToCart(cartItem).getOrThrow()
            true
        } else {
            // kreiraj novi cart sa prvom stavkom
            db.collection(FirestoreCollections.CARTS_COLLECTION)
                .add(
                    Cart(
                        legalEntityId = legalId,
                        userId = currentUserId,
                        contactId = legalId,
                        customerId = currentCustomerId.value,
                        items = listOf(cartItem)
                    )
                )
            true
        }
    }

    // -- Helpers --

    private suspend fun isCartCreated(): Boolean {
        val snap = db.collection(FirestoreCollections.CARTS_COLLECTION)
            .where {
                FirebaseFields.CUSTOMER_ID equalTo currentCustomerId.value
                FirebaseFields.LEGAL_ENTITY_ID equalTo legalId
            }
            .get()
        return snap.documents.isNotEmpty()
    }

    private suspend fun addItemToCart(cartItem: CartItem): Result<Boolean> = runCatching {
        val query = db.collection(FirestoreCollections.CARTS_COLLECTION)
            .where {
                FirebaseFields.CUSTOMER_ID equalTo currentCustomerId.value
                FirebaseFields.LEGAL_ENTITY_ID equalTo legalId
            }
            .get()

        val docRef = query.documents.firstOrNull()?.reference
            ?: return@runCatching true // Ako nema dokumenta, posmatraj kao uspeh (isto ponašanje)

        // arrayUnion u dev.gitlive.firebase
        docRef.update(
            mapOf(
                FirebaseFields.ITEMS to FieldValue.arrayUnion(cartItem)
            )
        )
        true
    }
}